import ProductContainer from "../../../../Components/Applications/ECommerce/Product/ProductContainer";

const Product = () => {
  return <ProductContainer />;
};

export default Product;
